<!-- Begin page -->
<div id="layout-wrapper" [attr.data-layout-direction]="currentLang === 'ar' ? 'rtl' : 'ltr'">
    <!-- Top Bar -->
        <app-topbar (mobileMenuButtonClicked)="onToggleMobileMenu()"></app-topbar>

    <!-- Side Bar -->
    <ng-container [ngSwitch]="currentSidebar">
    <ng-template ngSwitchDefault>
        <app-sidebar></app-sidebar>
    </ng-template>
</ng-container>
    <div class="main-content">
        <div class="page-content">
            <div class="container-fluid">
                <!-- Main Content -->
                <!-- Always show router-outlet content -->
                <router-outlet></router-outlet>
            </div>
        </div>
        <!-- Footer -->
        <app-footer></app-footer>
    </div>
</div>
<ngx-spinner type="ball-clip-rotate"></ngx-spinner>

<!-- RTL/LTR styles -->
<div *ngIf="currentLang === 'ar'" class="rtl-styles"></div>
